import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import LoadingPage from './LoadingPage';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import * as serviceWorker from './serviceWorker';
import './index.css';

const EU = React.lazy(() => import('./maps/EU')); // Lazy-loaded
const TheWorld = React.lazy(() => import('./maps/TheWorld')); // Lazy-loaded

ReactDOM.render(
  <React.StrictMode>
    <Router>
      <Switch>
        <Route path="/world">
          <Suspense fallback={<LoadingPage text="Lataa karttaa" />}>
            <TheWorld />
          </Suspense>
        </Route>
        <Route path="/">
          <Suspense fallback={<LoadingPage text="Lataa EU-karttaa" />}>
            <EU />
          </Suspense>
        </Route>
      </Switch>
    </Router>
  </React.StrictMode>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
